import { useAlert, AlertContent } from '../AlertContext';

export const useShowAlert = () => {
  const { showAlert } = useAlert();
  
  return (message: string, subMessage: string, status: 'success' | 'error') => {
    const alertContent: AlertContent = { message, subMessage, status };
    showAlert(alertContent);
  };
};